import { State } from 'define/types'
import { parseJson } from 'util/json'

const STORAGE_KEY = 'showoff'

interface StorageJson {
  left?: number
  right?: number
  window?: State
}

type Key = keyof StorageJson

function load(): StorageJson | undefined {
  let text: string | null = null
  try {
    text = localStorage.getItem(STORAGE_KEY)
  } catch {
    try {
      text = sessionStorage.getItem(STORAGE_KEY)
    } catch {
    }
  }
  return parseJson(text)
}

function save(json: StorageJson) {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(json))
    localStorage.setItem(STORAGE_KEY, JSON.stringify(json))
  } catch {
  }
}

function createStorage(): any {
  const json: StorageJson = load() ?? {}

  const handler: ProxyHandler<StorageJson> = {
    set(_target, key: Key, value, _receiver): boolean {
      if (value === undefined) delete json[key]
      else json[key] = value
      save(json)
      return true
    },
  }

  return new Proxy(json, handler)
}

export const storage: StorageJson = createStorage()

export function clearStorage() {
  for (const key of Object.keys(storage) as Key[]) {
    delete storage[key]
  }
}
